import {
  DetailedHTMLProps,
  ImgHTMLAttributes,
  useEffect,
  useState,
} from "react";

interface IProps
  extends DetailedHTMLProps<
    ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {}

export const ImageWrapper = (props: IProps) => {
  const [src, setSrc] = useState(props.src);

  useEffect(() => {
    setSrc(props.src);
  }, [props.src]);

  const onError = () => {
    setSrc("https://cdn.illio.com/images/logos/iex/02015-HK.png");
  };

  return <img {...props} key={props.src} src={src} onError={onError} />;
};
